export default {
  social_video: {
    '***': {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    metric: 100,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [{
                component: 'MetricVerticalArray',
                data: {
                  label: 'Persuasion',
                  metrics: [
                    {
                      metric: 122,
                      maxValue: 0.8,
                      format: '%,1'
                    },
                    {
                      metric: 121,
                      maxValue: 0.8,
                      format: '%,1'
                    }
                  ]
                }
              }],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Actions',
                    metrics: [
                      { metric: 123, isHeaderMetric: true, isCapitalized: true },
                      { metric: 124, isHeaderMetric: true },
                      { metric: 125, isHeaderMetric: true },
                      { metric: 126, isHeaderMetric: true },
                      { metric: 127, isHeaderMetric: true },
                      { metric: 128, isHeaderMetric: true },
                      { metric: 129, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },

          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Branding',
                    metrics: [
                      { metric: 237, isHeaderMetric: true },
                      { metric: 132, isHeaderMetric: true },
                      { metric: 133, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'Creative Efficiency',
                    mainMetric: {
                      // type: 'horizontal',
                      // scale: {
                      //   start: 85,
                      //   end: 155
                      // },
                      // metric: 200,
                      // label: 'Creative Summary Score'
                    },
                    subMetrics: [
                      { metric: 1, label: 'Compelling Content' },
                      { metric: 2, label: 'Brand Perceptions' },
                      { metric: 220, label: 'Brand Relevance' },
                      { metric: 270, label: 'Emotionally Engaging' },
                      { metric: 141, label: 'Brand Connection' },

                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 151,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 152,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: false,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total Consumers'
        }
      }
    }


  },
  social_post: {
    '***': {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    metric: 100,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [{
                component: 'MetricVerticalArray',
                data: {
                  label: 'Persuasion',
                  metrics: [
                    {
                      metric: 122,
                      maxValue: 0.8,
                      format: '%,1'
                    },
                    {
                      metric: 121,
                      maxValue: 0.8,
                      format: '%,1'
                    }
                  ]
                }
              }],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Actions',
                    metrics: [
                      { metric: 123, isHeaderMetric: true, isCapitalized: true },
                      { metric: 124, isHeaderMetric: true },
                      { metric: 125, isHeaderMetric: true },
                      { metric: 126, isHeaderMetric: true },
                      { metric: 127, isHeaderMetric: true },
                      { metric: 128, isHeaderMetric: true },
                      { metric: 129, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },

          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Branding',
                    metrics: [
                      { metric: 131, isHeaderMetric: true },
                      { metric: 132, isHeaderMetric: true },
                      { metric: 133, isHeaderMetric: true },
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'Creative Efficiency',
                    mainMetric: {
                      // type: 'horizontal',
                      // scale: {
                      //   start: 85,
                      //   end: 155
                      // },
                      // metric: 200,
                      // label: 'Creative Summary Score'
                    },
                    subMetrics: [
                      { metric: 1, label: 'Compelling Content' },
                      { metric: 2, label: 'Brand Perceptions' },
                      { metric: 220, label: 'Brand Relevance' },
                      { metric: 270, label: 'Emotionally Engaging' },
                      { metric: 141, label: 'Brand Connection' },

                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 151,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 152,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: false,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total Consumers'
        }
      }
    }


  },
  disney_radio: {
    '***': {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    metric: 100,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [{
                component: 'MetricVerticalArray',
                data: {
                  label: 'Persuasion',
                  metrics: [
                    {
                      metric: 122,
                      maxValue: 0.8,
                      format: '%,1'
                    },
                    {
                      metric: 121,
                      maxValue: 0.8,
                      format: '%,1'
                    }
                  ]
                }
              }],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Actions',
                    metrics: [
                      { metric: 123, isHeaderMetric: true, isCapitalized: true },
                      { metric: 124, isHeaderMetric: true },
                      { metric: 125, isHeaderMetric: true },
                      { metric: 126, isHeaderMetric: true },
                      { metric: 127, isHeaderMetric: true },
                      { metric: 128, isHeaderMetric: true },
                      { metric: 129, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },

          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Branding',
                    metrics: [
                      { metric: 131, isHeaderMetric: true },
                      { metric: 132, isHeaderMetric: true },
                      { metric: 133, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'Creative Efficiency',
                    mainMetric: {
                      // type: 'horizontal',
                      // scale: {
                      //   start: 85,
                      //   end: 155
                      // },
                      // metric: 200,
                      // label: 'Creative Summary Score'
                    },
                    subMetrics: [
                      { metric: 1, label: 'Compelling Content' },
                      { metric: 2, label: 'Brand Perceptions' },
                      { metric: 220, label: 'Brand Relevance' },
                      { metric: 270, label: 'Emotionally Engaging' },
                      { metric: 141, label: 'Brand Connection' },

                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 151,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 152,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: false,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total Consumers'
        }
      }
    }


  },
  disney_ooh: {
    '***': {
      headerHeight: 80,
      rowTitleHeight: 35,
      padding: 1,
      aspectRatio: 0.7727,
      externalHeaderHeight: 0,
      minContainerHeight: 1000,
      horizontalMargin: 10,
      verticalMargin: 10,
      rows: [
        {
          height: 0.33,
          title: 'IN-MARKET PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricDonut',
                  data: {
                    metric: 100,
                    metricScale: 200
                  }
                }
              ],
              width: 0.3,
              key: null
            },
            {
              content: [{
                component: 'MetricVerticalArray',
                data: {
                  label: 'Persuasion',
                  metrics: [
                    {
                      metric: 122,
                      maxValue: 0.8,
                      format: '%,1'
                    },
                    {
                      metric: 121,
                      maxValue: 0.8,
                      format: '%,1'
                    }
                  ]
                }
              }],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Actions',
                    metrics: [
                      { metric: 123, isHeaderMetric: true, isCapitalized: true },
                      { metric: 124, isHeaderMetric: true },
                      { metric: 125, isHeaderMetric: true },
                      { metric: 126, isHeaderMetric: true },
                      { metric: 127, isHeaderMetric: true },
                      { metric: 128, isHeaderMetric: true },
                      { metric: 129, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },

          ]
        },
        {
          height: 0.67,
          title: 'CREATIVE PERFORMANCE',
          data: [
            {
              content: [
                {
                  component: 'MetricTable',
                  data: {
                    label: 'Branding',
                    metrics: [
                      { metric: 131, isHeaderMetric: true },
                      { metric: 132, isHeaderMetric: true },
                      { metric: 133, isHeaderMetric: true }
                    ]
                  }
                }
              ],
              legend: {
                xOffset: 10,
                yOffset: -20
              },
              width: 0.3,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricChart',
                  data: {
                    title: 'Creative Efficiency',
                    mainMetric: {
                      // type: 'horizontal',
                      // scale: {
                      //   start: 85,
                      //   end: 155
                      // },
                      // metric: 200,
                      // label: 'Creative Summary Score'
                    },
                    subMetrics: [
                      { metric: 1, label: 'Compelling Content' },
                      { metric: 2, label: 'Brand Perceptions' },
                      { metric: 220, label: 'Brand Relevance' },
                      { metric: 270, label: 'Emotionally Engaging' },
                      { metric: 141, label: 'Brand Connection' },
                    ]
                  }
                }
              ],
              width: 0.35,
              key: null
            },
            {
              content: [
                {
                  component: 'MetricOpenend',
                  data: {
                    label: 'In Their Own Words',
                    topBox: {
                      likes: {
                        metric: 151,
                        noStatColor: '#BFBFBF'
                      },
                      dislikes: {
                        metric: 152,
                        noStatColor: '#AFABAB'
                      }
                    },
                    messageField: 'message',
                    wordcloudConfig: {
                      sentiments: [
                        { color: '#FF872F', description: 'Very Negative' },
                        { color: '#FFC397', description: 'Negative' },
                        { color: '#DAD9D6', description: 'Neutral' },
                        { color: '#C4E1AF', description: 'Positive' },
                        { color: '#89C35F', description: 'Very Positive' }
                      ],
                      scoreRange: [0, 7],
                      font: 'Arial, Helvetica, sans-serif',
                      showCounts: false,
                      padding: 5,
                      rotation: 0,
                      wordCountCutoff: 2,
                      wordLengthCutoff: 3,
                      numDisplayed: 100
                    }
                  }
                }
              ],
              width: 0.35,
              key: null
            }
          ]
        }
      ],
      legend: {
        metadataFields: [
          {
            value: 'last_month_tested',
            label: 'Last Tested'
          }
        ],
        includeSelections: true,
        includeStatTesting: true,
        includeFilters: {
          label: 'Target',
          default: 'Total Consumers'
        }
      }
    }


  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/quickview/index.js